import _ from 'lodash';
import apiFetch from '@scale/frontend-lib/api-fetch';
import {
  QualityOverTimeParams,
  QualityOverTimeResponse,
} from '@scale/shared/types/endpoints/customerQA/qualityOverTime';
import {
  TaskCompletionReportParams,
  TaskCompletionReportResponse,
} from '@scale/shared/types/endpoints/customerQA/reports/completion';

export async function getCustomerQAStats(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return apiFetch(null, `internal/customer_audit/stats`, { query });
}

export async function getQualityOverTime(
  params: QualityOverTimeParams,
): Promise<QualityOverTimeResponse> {
  const query = _.omitBy(params, _.isNil);
  return apiFetch(null, 'internal/customer_audit/charts/qualityOverTime', { query });
}

export async function getUseCustomerMetrics({ teamId }: $FIXME) {
  return apiFetch(null, `internal/customer_audit/overview2/use_customer_metrics?teamId=${teamId}`);
}

export async function getCustomerQATaskLevelReport(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return apiFetch(null, `internal/customer_audit/reports/taskLevel`, { query });
}

export async function getCustomerQAQualityReport(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/customer_audit/reports/quality`, { query });
}

export async function getCustomerQABatchesReport(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return apiFetch(null, `internal/customer_audit/reports/batches`, { query });
}

export async function getCustomerQABatchesQualityReport(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return apiFetch(null, `internal/customer_audit/reports/batchesQuality`, { query });
}

export async function getCustomerQATasksPerWeekReport(
  params: TaskCompletionReportParams,
): Promise<TaskCompletionReportResponse> {
  const query = _.omitBy(params, _.isNil);
  return apiFetch(null, `internal/customer_audit/reports/completion`, { query });
}
